/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfAllergensInner } from './PatchProductsRequestInnerAllOfAllergensInner';
import {
    PatchProductsRequestInnerAllOfAllergensInnerFromJSON,
    PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfAllergensInnerToJSON,
    PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfAllergensInner';

/**
 * 
 * @export
 * @interface UpdateModifiersRequestInner
 */
export interface UpdateModifiersRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateModifiersRequestInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifiersRequestInner
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifiersRequestInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifiersRequestInner
     */
    priceImpact?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifiersRequestInner
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifiersRequestInner
     */
    kitchenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifiersRequestInner
     */
    shortName?: string;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfAllergensInner>}
     * @memberof UpdateModifiersRequestInner
     */
    allergens?: Array<PatchProductsRequestInnerAllOfAllergensInner>;
}

/**
 * Check if a given object implements the UpdateModifiersRequestInner interface.
 */
export function instanceOfUpdateModifiersRequestInner(value: object): value is UpdateModifiersRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateModifiersRequestInnerFromJSON(json: any): UpdateModifiersRequestInner {
    return UpdateModifiersRequestInnerFromJSONTyped(json, false);
}

export function UpdateModifiersRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateModifiersRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
        'color': json['color'] == null ? undefined : json['color'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerFromJSON)),
    };
}

export function UpdateModifiersRequestInnerToJSON(json: any): UpdateModifiersRequestInner {
    return UpdateModifiersRequestInnerToJSONTyped(json, false);
}

export function UpdateModifiersRequestInnerToJSONTyped(value?: UpdateModifiersRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'priceImpact': value['priceImpact'],
        'color': value['color'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerToJSON)),
    };
}

